import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';

const OneImagePopup = ({ modal, onClose, image }) => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const updateDimensions = () => {
    setWindowHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  if (!image) return <></>;
  return (
    <Dialog fullWidth={true} maxWidth="lg" open={modal} onClose={onClose}>
      <DialogContent style={{ padding: 0 }}>
        <div className="d-flex" style={{ width: '100%', justifyContent: 'center' }} onClick={onClose}>
          <img src={image} alt="" style={{ objectFit: 'contain', height: windowHeight - Math.round(windowHeight / 5), maxWidth: '100%' }} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OneImagePopup;
